import { FC } from "react";
import {
  HEADED_SECTION_CONTENT_THEME_CLASS_MAP,
  THeadedSectionContentProps,
} from "./HeadedSection.config";
import { cn } from "@/ui/lib";

export const HeadedSectionContent: FC<THeadedSectionContentProps> = ({ children, theme }) => (
  <div
    data-component="HeadedSectionContent"
    className={cn(
      "flex flex-col space-y-4 p-4 border border-solid border-component-headed-section-base rounded-b-sys-xs",
      HEADED_SECTION_CONTENT_THEME_CLASS_MAP[theme],
    )}
  >
    { children }
  </div>
);
